import React, { useState, useEffect } from 'react';
import axios from 'axios';

interface StudentDropdownEditProps {
    studentId: string | number;
    initialCategory?: string;
}

const StudentDropdownEdit: React.FC<StudentDropdownEditProps> = ({ studentId, initialCategory }) => {
    const [selectedValue, setSelectedValue] = useState<string>(initialCategory || '');
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (initialCategory) {
            setSelectedValue(initialCategory);
        }
    }, [initialCategory]);

    const handleEditClick = async () => {
        if (!selectedValue || !studentId) {
            alert('Please select a value and make sure student ID is provided.');
            return;
        }

        try {
            setLoading(true);

            const baseURL = process.env.REACT_APP_BROADCAST_SERVER;
            if (!baseURL) {
                alert('Base URL for the API is not set.');
                return;
            }

            const response = await axios.get(`${baseURL}/activity-log/add-call-category`, {
                params: {
                    student_id: studentId,
                    call_category: selectedValue,
                },
            });

            if (response.data.success) {
                alert(response.data.message);
            } else {
                alert('Failed to update the call category.');
            }
        } catch (error) {
            console.error('Error updating call category:', error);
            alert('An error occurred while updating the call category.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="col-auto">
                <select
                    className="form-select height-40 rounded-pill lh-base"
                    style={{ width: '120px' }}
                    value={selectedValue}
                    onChange={(e) => setSelectedValue(e.target.value)}>
                    <option value="Select">Select</option>
                    <option value="Profile Update">Profile Update</option>
                    <option value="Guidance">Guidance</option>
                    <option value="Recruitment">Recruitment</option>
                    <option value="Fundraise">Fundraise</option>
                    <option value="Support Services">Support Services</option>

                    <option value="phone-call">Phone Call</option>
                    <option value="WhatsApp">WhatsApp</option>
                    <option value="Other">Other</option>
                </select>


            </div>
            <div className="col-auto">
                <button type="button" className="btn btn-border-gray height-40 rounded-pill d-flex align-items-center px-4" onClick={handleEditClick} disabled={loading}>
                    <span>{loading ? 'Saving...' : 'Edit'}</span>
                </button>
            </div>
        </>
    );
};

export default StudentDropdownEdit;
